export class AddToCartRequest {
  runnerId: number;
  userId: number;
  runnerMetadataMappingId: number;
  runnerAssetReleaseId: number;
  groupTypeCd: string;
  loginId: string;
}
